import { FloorViewOption } from 'types/service';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function organizeTablesBy(groupByKey: any): BaseTockAction {
  return {
    type: 'SET_ORGANIZING_TABLES_BY',
    payload: groupByKey,
    context: {
      shouldTrack: true,
      keyToTrack: 'payload',
    },
  };
}

export function selectRoom(id: string): BaseTockAction {
  return {
    type: 'SELECT_ROOM',
    payload: id,
    context: {
      shouldTrack: true,
    },
  };
}

export function selectView(view: FloorViewOption): BaseTockAction {
  return {
    type: 'SELECT_VIEW',
    payload: view,
    context: {
      shouldTrack: true,
      keyToTrack: 'payload',
    },
  };
}

export function setAerialOverlayVisibility(overlay: string, visibility: boolean) {
  return {
    type: 'SET_AERIAL_OVERLAY_VISIBILITY',
    payload: {
      overlay,
      visibility,
    },
    context: {
      shouldTrack: true,
      keyToTrack: 'payload.overlay',
    },
  };
}

export function setCanDragTables(canDragTables: boolean) {
  return {
    type: 'SET_CAN_DRAG_TABLES',
    payload: canDragTables,
    context: {
      shouldTrack: true,
      keyToTrack: 'payload',
    },
  };
}
